<mat-button-toggle-group appearance="legacy" class="toggle-group" multiple>
  @for (item of toggleItems; track item) {
    <mat-button-toggle (change)="preventDisabling($event, item.id)"
      (click)="toggle(item.id, $event.ctrlKey)"
      (contextmenu)="$event.preventDefault(); toggle(item.id, true)"
      [checked]="isToggled(item.id)"
      class="toggle">
      <div class="toggle-content">
        <div>{{ item.translateName ? (item.name | translate) : item.name }}</div>
        @if (item.count !== undefined) {
          <span class="count">{{ item.count }}</span>
        }
      </div>
    </mat-button-toggle>
  }
</mat-button-toggle-group>
